<script setup lang='ts'>
import { useMessage } from '@/composables/useNotification'
import { useChildCommentEvent } from '@/composables/useComment'
import type { CommonType } from '@/server/types'
import { LOAD_STATE } from '@/shared/types'

const props = withDefaults(defineProps<{
  dataId?: number | string
  dataType?: CommonType
  replyName?: string
  commentId?: number
  firstLevelIndex?: number
  secondLevelIndex?: number
}>(), {
  dataId: -1,
  dataType: 'complaint',
  replyName: '',
  commentId: -1,
  firstLevelIndex: -1,
  secondLevelIndex: -1,
})
const emit = defineEmits(['commentHandle', 'blurHandle'])

const { content, state, commentSubmit } = useComment()
const loading = computed(() => state.value === LOAD_STATE.LOADING)
async function commentHandle() {
  if (!props.commentId) {
    useMessage.warning('回复评论失败，请刷新页面重试')
    return
  }

  const result = await commentSubmit({
    dataType: props.dataType,
    dataId: Number(props.dataId),
    commentId: props.commentId,
  })

  if (result) {
    content.value = ''
    blurHandle()
    useChildCommentEvent().bus.emit({
      secondLevelIndex: props.secondLevelIndex,
      firstLevelIndex: props.firstLevelIndex,
      commentId: props.commentId,
      data: result,
      toUserName: props.replyName,
    })
    useMessage.success('回复评论成功')
  }
}

const inputRef = ref<HTMLInputElement | null>(null)
function blurHandle() {
  emit('blurHandle', {
    secondLevelIndex: props.secondLevelIndex,
    firstLevelIndex: props.firstLevelIndex,
    content: content.value,
  })
}
onMounted(() => {
  if (inputRef.value)
    inputRef.value.focus()
})
</script>

<template>
  <NInput
    ref="inputRef"
    v-model:value="content"
    class="bg-slate-1! rounded-md"
    type="textarea"
    :placeholder="`回复:${props.replyName}`"
    :autofocus="true"
    rows="1"
    minlength="10"
    maxlength="500"
    show-count
    @blur="blurHandle"
  />
  <div class="flex items-center justify-end mt-2.5">
    <button
      class="px-7.5 btn-primary "
      :class="[content.trim().length < 1 || loading ? 'cursor-not-allowed bg-blue-3' : 'cursor-pointer']"
      :disabled="content.trim().length < 1 || loading"
      @click="commentHandle"
    >
      <i v-if="loading" class="i-eos-icons:loading mr-1 vertical-icon" />
      <span>评论</span>
    </button>
  </div>
</template>
